import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PointStoreProductAssignService {

  constructor() { }

  makeNewAssignment() {
    let newAssignment = {
      CompanyID: 0,
      PointStoreProductID: 0,
      EmpGroupID: 0,
      EmpGroupLevel: 0,
      Name: '',
      GroupSubNames: '',
      GroupTypeName: '',
      isRemoved: false,
    };
    return newAssignment;
  }

  getNewAssignment() {
    return this.makeNewAssignment();
  }
}
